// extracted by mini-css-extract-plugin
export default {"link":"UA9z2","is-disabled":"iYRgh","is-inherit":"U0L0P","is-inverse":"KtOg5"};